import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/authContext';
import { callEdgeFunction } from './edgeFunction';

export interface PortalMembership {
  businessId: string;
  businessName: string | null;
  role: 'owner' | 'reception';
}

export interface PortalSessionResult {
  userId: string;
  aal: 'aal1' | 'aal2' | null;
  mfaEnrolled: boolean;
  memberships: PortalMembership[];
}

/** The business portal's session bootstrap — who is signed in, which
 * properties they belong to (the property switcher), and their AAL/MFA
 * state. Backed by the `portal-session` edge function. Scoped by the
 * signed-in user id in its query key so switching accounts never serves a
 * stale cache entry from a previous session. */
export function usePortalSession() {
  const { supabase, session } = useAuth();
  const userId = session?.user.id ?? null;
  return useQuery({
    queryKey: ['portal-session', userId],
    queryFn: () => callEdgeFunction<PortalSessionResult>(supabase, 'portal-session'),
    enabled: !!session,
    staleTime: 30_000,
  });
}
